/**
 * 计算两个日期之间的天数
 * @param {起始日期，分隔符“-”} strDateStart 
 * @param {终止日期，分隔符“-”} strDateEnd 
 */
function getDays(strDateStart, strDateEnd) {
  var strSeparator = "-"; //日期分隔符
  var oDate1;
  var oDate2;
  var iDays;
  oDate1 = strDateStart.split(strSeparator);
  oDate2 = strDateEnd.split(strSeparator);
  var strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
  var strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
  iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24);//把相差的毫秒数转换为天数
  return iDays;
}
/**
 * 去掉字符串中的html标签
 * @param {格式化字符串} msgtxt 
 */
var filterHTMLTag = function (msgtxt) {
  var msg = msgtxt.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
  msg = msg.replace(/[|]*\n/, '') //去除行尾空格
  msg = msg.replace(/&npsp;/ig, ''); //去掉npsp
  msg = msg.replace(/&nbsp;/ig, ''); //去掉npsp
  return msg;
}
/**
 * 是否为空字符串
 * @param str 字符串
 * @returns {boolean} 如果为空则为true
 */
function isNullOrWhiteSpace(str) {
  if (!str) return true
  let reg = new RegExp("^[ ]+$");
  return reg.test(str);
}

/**
 * 判断是否为空HTML字符串
 * @param {html字符串} html 
 */
function isNullOrBlankHtml(html) {
  if (html == undefined) return true;
  if (/<img +.*?src *?=.*?>/.test(html)) return false;
  if (/<audio +.*?src *?=.*?>/.test(html)) return false;
  if (/<video +.*?src *?=.*?>/.test(html)) return false;

  return html.replace(/<.*?>/g, '').replace(/&nbsp;/g, "").replace(/&emsp;/g, "").replace(/&ensp;/g, '').replace(/&thinsp;/g, '').trim() == '';
}
/**
 * 
 * @param {通知的标题} title 
 * @param {通知的内容} msg 
 * @param {通知的类型：'success'、'warning'、'info'、'error'} type 
 * @param {调用的对象} that 
 */
function showNotify(title, msg, type, that) {
  const h = that.$createElement;
  that.$notify({
    title: title,
    message: h("i", {
      style: "color: teal"
    }, msg),
    type: type
  });
}
/**
 * 格式化日期和时间
 * @param {日期} date 
 * @param {格式} fmt 
 */
function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(num, length) {
  if (length == undefined) length = 2;
  var len = length;
  if (length < num.length) len = num.length;
  var temp = '0000000000000000000' + num;
  return temp.substr(temp.length - len);
}

function formatTime(sec) {
  let second = sec % 60;
  let second_str = padLeftZero(second, 2);
  let minute = 0;
  let hour = 0;
  let hour_str = "";
  let minute_str = "";
  if (sec > 3599) {
    hour = Math.floor(sec / 3600);
    hour_str = padLeftZero(hour, 2);
  }
  if (sec > 59) {
    minute = Math.floor((sec - hour * 3600) / 60);
    minute_str = padLeftZero(minute, 2);
  }
  return (hour_str == "" ? "" : (hour_str + " : ")) + (minute_str == "" ? "" : (minute_str + " : ")) + second_str;
}


// 格式化文件大小 单位：Bytes、KB、MB、GB
function formatFileSize(fileSize) {
  if (fileSize < 1024) {
    return fileSize + 'B';
  } else if (fileSize < (1024 * 1024)) {
    let temp = fileSize / 1024;
    temp = temp.toFixed(2);
    return temp + 'K';
  } else if (fileSize < (1024 * 1024 * 1024)) {
    let temp = fileSize / (1024 * 1024);
    temp = temp.toFixed(2);
    return temp + 'M';
  } else {
    let temp = fileSize / (1024 * 1024 * 1024);
    temp = temp.toFixed(2);
    return temp + 'G';
  }
}

//by函数接受一个成员名字符串做为参数
//并返回一个可以用来对包含该成员的对象数组进行排序的比较函数
let sortBy = function (name) {
  return function (o, p) {
    let a, b;
    if (typeof o === "object" && typeof p === "object" && o && p) {
      a = o[name];
      b = p[name];
      if (a === b) {
        return 0;
      }
      if (typeof a === typeof b) {
        return a < b ? -1 : 1;
      }
      return typeof a < typeof b ? -1 : 1;
    }
    else {
      throw ("error");
    }
  }
}

function formatTreeviewData(categories) {
  let treeData = [];
  categories.sort((a, b) => {
    if (a.edjcode > b.edjcode) {
      return 1;
    } else if (a.edjcode > b.edjcode) {
      return -1;
    } else return 0;
  });
  treeData.push(categories[0]);
  treeData[0].children = [];
  for (let i = 1; i < categories.length; i++) {
    categories[i].children = [];
    findParent(treeData[0], categories[i]);
  }
  return treeData;
}

let childrenFlag = false;
let selectedNode = {};
/**
 * 寻找第一个叶子节点
 * @param {tree的数据} treeData 
 */
function findFirstLeafNode(treeData) {
  childrenFlag = false;
  selectedNode = {};
  FindFirstLeafNode(treeData);
  return selectedNode;
}
function FindFirstLeafNode(treeData) {
  for (let i = 0; i < treeData.children.length; i++) {
    let v = treeData.children[i];
    if (v.children.length == 0) {
      if (!childrenFlag) {
        childrenFlag = true;
        selectedNode = v;
      }
    }
    else {
      FindFirstLeafNode(v);
    }
  }
}

/**
 * 寻找父节点
 * @param {} td 
 * @param {*} ele 
 */
function findParent(td, ele) {
  if (ele.pid == td.id) {
    td.children.push(ele);
    return;
  }
  td.children.forEach(element => {
    findParent(element, ele);
  });
}

function isNumber(obj) {
  return !isNaN(parseFloat(obj)) && isFinite(obj);
}

function int2char(val) {
  return String.fromCharCode(val);
}

/**
 * 删除第一个p标签
 * @param {待删除的字符串} html 
 */
function delFirstTagP(html) {
  let zhan = [];
  let i = 0;
  let flag = false;
  let firstFlag = true;
  let start = 0;
  while (i < html.length - 3) {
    if (html[i] == '<' && html[i + 1] == 'p') {
      if (firstFlag) {
        start = i;
        firstFlag = false;
      }

      flag = true;
    }
    else if (html[i] == '>' && flag) {
      flag = false
      zhan.push(i + 1)
    }
    else if (html[i] == '<' && html[i + 1] == '/' && html[i + 2] == 'p' && html[i + 3] == '>') {

      if (zhan.length == 1) {
        return html.substr(0, start) + html.substr(zhan[0], i - zhan[0]) + html.substr(i + 4);
      }
      zhan.pop();
    }
    i++;
  }
}
let subjects = [
  { id: 1, name: "语文", code: '0101', abbr: 'yw' },
  { id: 2, name: "数学", code: '0201', abbr: 'sx' },
  { id: 3, name: "英语", code: '0102', abbr: 'yy' },
  { id: 4, name: "物理", code: '0401', abbr: 'wl' },
  { id: 5, name: "化学", code: '0402', abbr: 'hx' },
  { id: 6, name: "生物", code: '0403', abbr: 'sw' },
  { id: 8, name: "历史", code: '0307', abbr: 'ls' },
  { id: 9, name: "地理", code: '0308', abbr: 'dl' },
  { id: 7, name: "政治", code: '0301', abbr: 'zz' },
  { id: 60, name: "文数", code: '0202', abbr: 'ws' }
]

let findParentNode = (nodes, n) => {
  nodes.forEach(node => {
    if (n.parent_id == node.id) {
      node.children.push(n);
      return;
    } else {
      findParentNode(node.children, n);
    }
  });
}

let createErlunTreeview = (res) => {
  let skd = {};
  let topnode = res.data[0];
  skd.id = topnode.id;
  skd.label = topnode.title;
  skd.leaf = topnode.subCount == 0;
  skd.children = [];
  let tns = [];
  for (let i = 1; i < res.data.length; i++) {
    let tskd = {};
    let tn = res.data[i];
    tskd.id = tn.id;
    tskd.label = tn.title;
    tskd.leaf = tn.subCount == 0;
    tskd.parent_id = tn.parentId;
    tskd.children = [];
    if (tskd.parent_id == skd.id) {
      tns.push(tskd);
    } else {
      findParentNode(tns, tskd);
    }
  }
  return tns;

}

let createMotkTreeview = (res) => {
  let subject_knowledge_data = [];

  let root = {};
  res.data.forEach(ele => {

    let skd = {};
    skd.id = ele.id;
    skd.label = ele.name;
    skd.leaf = ele.subCount == 0;
    skd.children = [];
    subject_knowledge_data.push(skd);

  });

  //eslint-disable-next-line
  console.log(root, "root")
  return subject_knowledge_data;
}
/**
 * 创建模拟考试的导航树
 * @param {} res 
 */
let createMockTreeview = (res) => {
  let subject_mock_examination_data = [];
  let skd = {};
  let topnode = res.data[0];
  skd.id = topnode.id;
  skd.label = topnode.title;
  skd.leaf = topnode.subCount == 0;
  skd.children = [];
  subject_mock_examination_data.push(skd);
  for (let i = 1; i < res.data.length; i++) {
    let tskd = {};
    let tn = res.data[i];
    tskd.id = tn.id;
    tskd.label = tn.title;
    tskd.leaf = tn.subCount == 0;
    tskd.children = [];
    skd.children.push(tskd);
  }
  return subject_mock_examination_data;
}

let getMotkSubjectID = function (subject_id, term_id) {
  let motk_subject_id = 0;
  if (term_id == undefined) term_id = 3;
  if (term_id == 1) {
    switch (subject_id) {
      case 1: motk_subject_id = 21; break;
      case 2: motk_subject_id = 22; break;
      case 3: motk_subject_id = 23; break;
      case 50: motk_subject_id = 20; break;
    }
  } else if (term_id == 2) {
    switch (subject_id) {
      case 1: motk_subject_id = 1; break;
      case 2: motk_subject_id = 2; break;
      case 3: motk_subject_id = 3; break;
      case 4: motk_subject_id = 4; break;
      case 5: motk_subject_id = 5; break;
      case 6: motk_subject_id = 6; break;
      case 7: motk_subject_id = 19; break;
      case 8: motk_subject_id = 7; break;
      case 9: motk_subject_id = 8; break;
      case 13: motk_subject_id = 24; break;
    }
  } else if (term_id == 3) {
    switch (subject_id) {
      case 1: motk_subject_id = 9; break;
      case 2: motk_subject_id = 10; break;
      case 3: motk_subject_id = 11; break;
      case 4: motk_subject_id = 12; break;
      case 5: motk_subject_id = 13; break;
      case 6: motk_subject_id = 14; break;
      case 7: motk_subject_id = 17; break;
      case 8: motk_subject_id = 15; break;
      case 9: motk_subject_id = 16; break;
      case 60: motk_subject_id = 28; break;
    }
  }
  return motk_subject_id;
}

let getMotkTeacherCode = function (subject_id, term_id) {

  let rndstr = randomString(6);
  let teacher_name = rndstr;
  if (term_id == undefined) term_id = 3;
  if (term_id == 1) {
    switch (subject_id) {
      case 1: teacher_name = "xxywteacher" + rndstr; break;
      case 2: teacher_name = "xxsxteacher" + rndstr; break;
      case 3: teacher_name = "xxyyteacher" + rndstr; break;
      case 50: teacher_name = "xxkxteacher" + rndstr; break;
    }
  } else if (term_id == 2) {
    switch (subject_id) {
      case 1: teacher_name = "czywteacher" + rndstr; break;
      case 2: teacher_name = "czsxteacher" + rndstr; break;
      case 3: teacher_name = "czyyteacher" + rndstr; break;
      case 4: teacher_name = "czwlteacher" + rndstr; break;
      case 5: teacher_name = "czhxteacher" + rndstr; break;
      case 6: teacher_name = "czswteacher" + rndstr; break;
      case 7: teacher_name = "czlsteacher" + rndstr; break;
      case 8: teacher_name = "czdlteacher" + rndstr; break;
      case 9: teacher_name = "czzzteacher" + rndstr; break;
      case 13: teacher_name = "czkxteacher" + rndstr; break;
    }
  } else if (term_id == 3) {
    switch (subject_id) {
      case 1: teacher_name = "gzywteacher" + rndstr; break;
      case 2: teacher_name = "gzsxteacher" + rndstr; break;
      case 3: teacher_name = "gzyyteacher" + rndstr; break;
      case 4: teacher_name = "gzwlteacher" + rndstr; break;
      case 5: teacher_name = "gzhxteacher" + rndstr; break;
      case 6: teacher_name = "gzswteacher" + rndstr; break;
      case 7: teacher_name = "gzlsteacher" + rndstr; break;
      case 8: teacher_name = "gzdlteacher" + rndstr; break;
      case 9: teacher_name = "gzzzteacher" + rndstr; break;
      case 60: teacher_name = "gzkxteacher" + rndstr; break;
    }
  }
  return teacher_name;
}


let getGaokaoYear = () => {
  let date = new Date();
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();
  if (m > 6 || (m == 6 && d > 10)) y++;
  return y;
}
let motk_question_levels = [{ level: 1, name: "容易" }, { level: 2, name: "较易" }, { level: 3, name: "一般" }, { level: 4, name: "较难" }, { level: 5, name: "困难" }];


function randomString(len) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

let isLogon=false;
let motkKnowledgePointTree={};
let showAnalysis=false;
let showAnswer=false;

export default {
  isNumber,
  isNullOrWhiteSpace,
  isNullOrBlankHtml,
  showNotify,
  formatDate,
  filterHTMLTag,
  formatFileSize,
  sortBy,
  formatTreeviewData,
  int2char,
  formatTime,
  findFirstLeafNode,
  delFirstTagP,
  getDays,
  motk_question_levels,
  subjects,
  findParentNode,
  createErlunTreeview,
  createMockTreeview,
  createMotkTreeview,
  getGaokaoYear,
  getMotkSubjectID,
  randomString,
  getMotkTeacherCode,
  isLogon,
  motkKnowledgePointTree,
  showAnswer,
  showAnalysis
}